import { useAppSettings } from "@skv/state";
import * as React from "react";
import { Link, useLocation, useRouteMatch } from "react-router-dom";

import {
  ROUTE_APPLICATIONS,
  ROUTE_EMAIL_ALERTS,
  ROUTE_EXPERIENCES,
  ROUTE_OPPORTUNITIES,
  ROUTE_ORGANISATIONS,
  ROUTES_FAVOURITES,
  ROUTES_OPPORTUNITIES,
  ROUTES_ORGANISATIONS,
} from "~/constants";

export const Breadcrumb: React.FC<Record<string, never>> = (props) => {
  const { applicationName, homeUrl } = useAppSettings();
  const location = useLocation();
  const isOpp = useRouteMatch(ROUTES_OPPORTUNITIES);
  const isOrg = useRouteMatch(ROUTES_ORGANISATIONS);
  const isFavourites = useRouteMatch(ROUTES_FAVOURITES);
  const isMyEmailAlerts = useRouteMatch(ROUTE_EMAIL_ALERTS);
  const isMyExperiences = useRouteMatch(ROUTE_EXPERIENCES);
  const isMyApplications = useRouteMatch(ROUTE_APPLICATIONS);

  const isMyActivity =
    isFavourites || isMyEmailAlerts || isMyExperiences || isMyApplications;

  const matchOppDetails = useRouteMatch("/volunteering/:id/*");
  const matchOppApply = useRouteMatch("/volunteering/*/apply");

  const isOppDetails = matchOppDetails && matchOppDetails.isExact;
  const isOppApplication = matchOppApply && matchOppApply.isExact;

  const matchOrgDetails = useRouteMatch("/volunteering-organisations/:id/*");
  const isOrgDetails = matchOrgDetails && matchOrgDetails.isExact;

  function getTitleFromUrl(url: string) {
    const unformattedTitle = url.split("/").pop();
    return unformattedTitle
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <section>
      <div
        className="nsw-container"
        css={`
          padding-top: 0.75rem;
          padding-bottom: 0.75rem;
        `}
      >
        <nav aria-label="Breadcrumb" className="nsw-breadcrumbs mt-0">
          <ol>
            <li>
              <a href={homeUrl}>Home</a>
            </li>
            <li>
              <Link
                to="/"
                className={location.pathname === "/" ? "current" : ""}
                aria-current={location.pathname === "/" ? "page" : false}
              >
                {applicationName}
              </Link>
            </li>
            {(isOpp || isOrg || isMyActivity) && (
              <li>
                {isOpp ? (
                  <Link
                    to={ROUTE_OPPORTUNITIES}
                    className={isOpp && isOpp.isExact ? "current" : ""}
                    aria-current={isOpp && isOpp.isExact ? "page" : false}
                  >
                    Opportunities
                  </Link>
                ) : isOrg ? (
                  <Link
                    to={ROUTE_ORGANISATIONS}
                    className={isOrg && isOrg.isExact ? "current" : ""}
                    aria-current={isOrg && isOrg.isExact ? "page" : false}
                  >
                    Organisations
                  </Link>
                ) : isFavourites ? (
                  <span className="current" aria-current="page">
                    My favourites
                  </span>
                ) : isMyEmailAlerts ? (
                  <span className="current" aria-current="page">
                    My email alerts
                  </span>
                ) : isMyExperiences ? (
                  <span className="current" aria-current="page">
                    My experiences
                  </span>
                ) : isMyApplications ? (
                  <span className="current" aria-current="page">
                    My applications
                  </span>
                ) : null}
              </li>
            )}
            {(isOppDetails || isOppApplication || isOrgDetails) && (
              <li>
                <span className="current" aria-current="page">
                  {isOppApplication
                    ? getTitleFromUrl(matchOppApply.url)
                    : isOppDetails
                    ? getTitleFromUrl(matchOppDetails.url)
                    : getTitleFromUrl(matchOrgDetails.url)}
                </span>
              </li>
            )}
          </ol>
        </nav>
      </div>
    </section>
  );
};
